export const REGISTRO_COMPRAS = 'REG_COMPRAS'
export const REGISTRO_VENTAS = 'REG_VENTAS'
export const CARGA_DIARIO = 'CARGA_DIARIO'

export const __dictionary = {
  [REGISTRO_COMPRAS]: {
    id: REGISTRO_COMPRAS,
    nombre: 'Registro compras'
  },
  [REGISTRO_VENTAS]: {
    id: REGISTRO_VENTAS,
    nombre: 'Registro ventas'
  },
  [CARGA_DIARIO]: {
    id: CARGA_DIARIO,
    nombre: 'Carga diario'
  }
}

export const __array = [__dictionary[REGISTRO_COMPRAS], __dictionary[REGISTRO_VENTAS], __dictionary[CARGA_DIARIO]]
